import { useQuery } from 'react-query';

import { api } from '../api';

interface ITransactionLow {
  item: string;
  dtBaixa: Date;
  vlPgto: number;
  vlTxAdm: number;
  vlTxAnt: number;
  vlLocacao: number;
  vlOutrosDesc: number;
}

export async function getOrdemRepasseBaixa(
  id: string | undefined
): Promise<ITransactionLow[]> {
  const { data } = await api.get(`transactions/ordem-repasse-baixa/${id}`);

  return data;
}

export function useOrdemRepasseBaixa(id: string | undefined) {
  return useQuery(['repasse-baixa', id], () => getOrdemRepasseBaixa(id), {
    staleTime: Infinity,
    retry: 2
  });
}
